import { render, staticRenderFns } from "./DepartmentTeam.vue?vue&type=template&id=66fe298c"
import script from "./DepartmentTeam.vue?vue&type=script&lang=js"
export * from "./DepartmentTeam.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports